import { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { reducerActions } from "../../../Reducers/FormReducer";
import 'react-bootstrap-typeahead/css/Typeahead.css';

const TypeaheadBase = forwardRef((props, ref) => {
  
    const hiddenInputRef = useRef(); // for native validation
    const {
        field,
        objectkey,   
        error,
        touched,
        dispatchState
      } = props;


    const handleChange = (selected) => {
      dispatchState({ 
        type: reducerActions.ON_CHANGE_TYPEAHEAD, 
        payload: { 
          key:objectkey,
          value: selected 
        } 
      });
    };
  
    const handleBlur = () => {
      dispatchState({
        type: reducerActions.ON_BLUR_TYPEAHEAD,
          payload: { 
            key:objectkey       
          } 
      });
      
    };

  const typeaheadRef = useRef();

  return (
    <>
      <label htmlFor={field.fieldId}>
        {field.fieldLabel || field.fieldName}
        {field.fieldRequired && <span className="text-danger">*</span>}
        &nbsp;
      </label>
      <span className="input-wrapper">
        <Typeahead
          ref={typeaheadRef}
          id={field.fieldId}
          selected={field.fieldValue || []}
          options={props.options || []}
          onChange={handleChange}
          onBlur={handleBlur}
          align="left"
          isInvalid={touched && !!error}
          allowNew   
          newSelectionPrefix="Other: "
       
          placeholder={field.placeholder || "Choose..."}
          menuStyle={{ overflowx: 'hidden' }} 
          size="sm"  
        />

        {/* Hidden input to allow native validation API compatibility */}
        <input
          ref={hiddenInputRef}
          style={{ display: "none" }}
          required={field.fieldRequired}
          value={field.fieldValue || ""}
          onChange={() => {}}
        />

        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          {error}
        </Form.Control.Feedback>
      </span>
    </>
  );
});

export default TypeaheadBase;